<template>
    <b-container v-if="loaded" fluid class="p-0">
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">
                        Detalhes da Programacao
                    </span>
                    <btn-voltar />
                    <btn-excluir v-if="modoExclusao" :excluirItem="callExcluir" :idItem="1" botao
                        class="float-right mt-1" />
                </h6>
            </template>
            <b-tabs card fill>
                <b-tab>
                    <template #title>
                        <font-awesome-icon icon="pencil" class="mr-1 text-info" v-b-tooltip.hover title="Dados da programação" />
                        <span class="d-none d-md-inline">Dados iniciais</span>
                    </template>
                    <div>
                        <b-row class="mt-2">
                            <b-col><strong>Nome do Evento: </strong><span>{{programacao.NmEvento }}</span></b-col>
                            <b-col><strong>Tipo do Evento: </strong><span>{{programacao.TipoEvento.DeTipoEvento}}</span></b-col>
                        </b-row>
                    </div>
                </b-tab>
                <b-tab lazy>
                    <template #title>
                        <font-awesome-icon icon="users" class="mr-1 text-info" v-b-tooltip.hover title="Atrações artísticas" />
                        <span class="d-none d-md-inline">Atrações Artísticas</span>
                    </template>
                    <detalhes-atracoes-artisticas :prog=programacao></detalhes-atracoes-artisticas>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script lang="ts">
import DetalhesAtracoesArtisticas from '@/components/licitacoes/programacao-evento/DetalhesAtracoesArtisticas.vue'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import programacaoService from '@/services/eventos/programacaoService'
import { store } from "@/store"
import { fieldsLogsEventos } from '@/types/licitacoes/fields-logs-eventos'
import { LogEvento } from '@/types/licitacoes/log-evento'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'
import { Programacao } from '@/types/eventos/programacao/programacao'

const CompProps = Vue.extend({
    name: 'DetalhesProgramacao',
    components: {
        BtnExcluir, BtnVoltar, DetalhesAtracoesArtisticas
    },
    props: {
        idProgramacao: {
            type: String,
            required: true
        }
    }
})


@Component
export default class DetalhesProgramacao extends mixins(UtilsTS, CompProps) {
    loaded = false
    tableBusy = false
    programacao: Programacao = new Programacao()
    itemsLogs: LogEvento[] = []
    fieldsLogs: TableField[] = fieldsLogsEventos
    currentPageLogs = 1

    get modoExclusao() {
        return 'excluir' in this.$route.query
    }

    async mounted() {
        try {
            store.blockScreen = true
            this.programacao = await programacaoService.buscarProgramacao(this.idProgramacao)
            this.programacao.tratarDadosDaAPI()
        }
        catch (e: any) {
            console.error('Erro ao montar detalhes da programação', e)
            this.$router.push("/modulo-eventos/programacoes");
            this.$toast.error(e.message || "Erro ao carregar programação");
        } finally {
            this.loaded = true
            store.blockScreen = false
        }
    }

    async callExcluir() {
        try {
            store.blockScreen = true
            const response = await programacaoService.removerProgramacao(+this.idProgramacao)
            if (response) {
                this.$toast.success('Programação excluída com sucesso')
                this.$router.push("/modulo-eventos/programacoes");
            } else {
                this.$toast.error('Erro ao excluir Contrato/O.F.')
            }
        } catch (error: any) {
            this.tratarError(error)
        } finally {
            store.blockScreen = false
        }
    }

}
</script>

<style></style>